export default __webpack_public_path__ + "static/media/save-key.1e6f5df8.svg";